/**
 * Updates an image url to resize a sponsored list image
 * https://github.com/alltrails/explore-service/blob/alpha/api/.bundle/spec.yaml#L1730
 *
 * @param url - The url of the unsized sponsored list image
 * @param width - The desired width
 * @param height - The desired height
 * @returns The url of the sized sponsored list image
 */
const getSizedSponsoredListImageUrl = (url: string, width: number, height: number) => {
  const sizeString = `?resize=${width},${height}`;
  return `${url}${sizeString}`;
};

export default getSizedSponsoredListImageUrl;
